const state = {
  filtros_gerais: {},
};

const getters = {
  filtros_gerais: (state) => state.filtros_gerais,
};

const mutations = {
  SET_FILTROS_GERAIS(state, filtros) {
    state.filtros_gerais = filtros;
  },
};

const actions = {
  atualizarFiltrosGerais({commit}, filtros) {
    commit('SET_FILTROS_GERAIS', filtros);
  }
}

export default {namespaced: true, state, mutations, getters, actions};
